import Vue from 'vue'
import VueApollo from "vue-apollo"
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context';
import fetch from 'unfetch'
import store from 'store'

Vue.use(VueApollo)

// HTTP connexion to the API
const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: process.env.GRAPHQL_API_BASE, // 'http://localhost:3020/graphql',
  credentials: 'same-origin',
  fetch: fetch
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const { authToken } = store.state.currentUser
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: authToken ? `Bearer ${authToken}` : '',
    }
  }
});

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
})

export const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})



// // Adds authorization token to requests
// api.interceptors.request.use(config => {
//   const { authToken } = store.state.currentUser
//   if (authToken !== null) {
//     config.headers.Authorization = `Bearer ${authToken}`
//   }
//   return config
// })



// WEBPACK FOOTER //
// ./src/graphql/apollo.js